import type { DataAction } from '../../../types/dataAction.type';

export const UPDATE_ARCHIVED_FILTER = 'UPDATE_ARCHIVED_FILTER' as const;

export const updateArchivedFilter = (archived: boolean) => ({ data: { archived }, type: UPDATE_ARCHIVED_FILTER });

export type UpdateArchivedFilterResponseAction = DataAction<typeof UPDATE_ARCHIVED_FILTER, { archived: boolean }>;
